const bmSupport = {
  id: `BM`,
  text: `Your Business Manager plays a key role in customizing your HR strategy, leveraging insights to select the best training programs and adjust services to fit your unique business needs. They work closely with your Dedicated HR Manager to optimize HR operations and resource use, ensuring Bambee's services enhance your business.`,
  notes: `Business Manager`,
  list: [
    `Employee Training Program Consultations`,
    `Service Level Exploration`,
    `Subscription Management`,
    `Account Expansion`,
  ],
} as const;

export default bmSupport;
